import Box from "@mui/material/Box";
import { truncateNumber } from "src/domains/shared/utils/truncateNumber";

/**
 * 좌표 포인트 한 줄 표시 — P1, P2... 번호 + x/y/z (2자리 소수점). 교대 행 배경색.
 */
interface PointLocationProps {
  location: { x: number; y: number; z: number };
  index: number;
}

export function PointLocation({
  location,
  index,
}: Readonly<PointLocationProps>) {
  return (
    <Box
      sx={{
        padding: "6px 8px",
        height: "34px",
        display: "flex",
        gap: "30px",
        backgroundColor: index % 2 === 1 ? "#fafafa" : "transparent",
      }}
    >
      <Box
        component="span"
        sx={{
          minWidth: "15px",
          fontSize: "14px",
          fontWeight: 500,
          color: "#757575",
          letterSpacing: "0.1px",
          lineHeight: "21.98px",
        }}
      >
        {`P${index + 1}`}
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "10px",
        }}
      >
        <Box
          component="span"
          sx={{
            minWidth: "65px",
            fontSize: "14px",
            fontWeight: 500,
            color: "rgba(0, 0, 0, 0.87)",
            letterSpacing: "0.1px",
            lineHeight: "21.98px",
          }}
        >
          {truncateNumber(location.x, 2)}
        </Box>
        <Box
          component="span"
          sx={{
            minWidth: "65px",
            fontSize: "14px",
            fontWeight: 500,
            color: "rgba(0, 0, 0, 0.87)",
            letterSpacing: "0.1px",
            lineHeight: "21.98px",
          }}
        >
          {truncateNumber(location.y, 2)}
        </Box>
        <Box
          component="span"
          sx={{
            minWidth: "45px",
            fontSize: "14px",
            fontWeight: 500,
            color: "rgba(0, 0, 0, 0.87)",
            letterSpacing: "0.1px",
            lineHeight: "21.98px",
          }}
        >
          {location.z > -1000 ? truncateNumber(location.z, 2) : "-"}
        </Box>
      </Box>
    </Box>
  );
}
